<div class="container-fluid mt-3 g-0 px-3">

    <div class="row">
        <div class="col">

            <mat-form-field class="w-100">
                <mat-label i18n>Date de début</mat-label>
                <input matInput i18n-placeholder placeholder="Date de début" [(ngModel)]="Filters.DateDebut" [matDatepicker]="picker" (focus)="picker.open()"
                       required>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Date de fin</mat-label>
                <input matInput i18n-placeholder placeholder="Date de fin" [(ngModel)]="Filters.DateFin" [matDatepicker]="picker2" (focus)="picker2.open()"
                       required>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col">

            <mat-form-field class="w-100">
                <mat-label i18n>Projet</mat-label>
                <input matInput [(ngModel)]="Filters.Projet" i18n-placeholder placeholder="Projet" required>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label i18n>Code Dossier</mat-label>
                <input matInput [(ngModel)]="Filters.CodeDossier" i18n-placeholder placeholder="Code Dossier" required>
            </mat-form-field>
        </div>

        <div class="col">

            <mat-form-field class="w-100" appearance="fill">
                <!-- <mat-label i18n>Référence EOL</mat-label> -->
                <input class="ms-n1" matInput [(ngModel)]="Filters.ReferenceEOL" i18n-placeholder placeholder="Référence EOL " required>
                <div class="ms-3" matPrefix>006-10514-</div>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label i18n>Référence client</mat-label>
                <input class="ms-n1" matInput [(ngModel)]="Filters.ReferenceClient" i18n-placeholder placeholder="Référence client " required>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <input class="ms-n1" matInput [(ngModel)]="Filters.MainContactName" i18n-placeholder placeholder="Contact Dossier" required>
            </mat-form-field>
        </div>
    </div>
    <div class="row align-items-center my-3">
        <div class="col-3">
            <button appPreventDoubleClick class="w-100" color="primary" mat-raised-button (throttledClick)="searchSampleByFilters()" [disabled]="Task.IsLoading > 0" i18n>
                Chercher
            </button>
        </div>
        <div class="col-auto">
            <button appPreventDoubleClick class="w-100" color="accent" mat-raised-button (throttledClick)="toggleAllRows()" [disabled]="Task.IsLoading > 0" i18n>
                Tout selectionner
            </button>
        </div>
        @if (hasLineBlocked()) {
        <div class="col-auto fst-italic alert-color">*Problèmes de recouvrement</div>
        }
        <div class="col"></div>
        <div class="col-auto">
            <mat-form-field appearance="fill">
                <mat-label i18n>Configuration</mat-label>
                <mat-select [(ngModel)]="SelectedConfiguration" name="configuration" [disabled]="selection.selected.length === 0">
                    @for (conf of AvailableConfigurationList; track conf.Code) {
                    <mat-option [value]="conf">
                        {{conf.Name}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-auto">
            <button appPreventDoubleClick class="w-100" color="accent" mat-raised-button (throttledClick)="export()" [disabled]="!SelectedConfiguration" i18n>
                Exporter
            </button>
        </div>
    </div>

    @for (batchList of SampleList; track batchList) {
    <div class="row align-items-center border rounded-1 background-light p-3 my-3" [style.color]="hasSampleBlockedInBatch(batchList[0].BatchCode) ? 'red' : ''">
        <h5 class="col-auto text-center">Dossier {{batchList[0].BatchCode}} </h5>
        <h5 class="col text-truncate"> {{batchList[0].Project}} </h5>
        <h5 class="col-auto"> {{batchList[0].EolReference}} </h5>
        <h5 class="col-auto"> {{batchList[0].ReceptionDate | date: 'shortDate'}} </h5>

        <div class="col-auto">
            <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1" (throttledClick)="setBatchVisibility(batchList[0])">

                @if (!batchList[0].IsVisible) {
                <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
                }
                @if (batchList[0].IsVisible) {
                <mat-icon class="material-symbols-outlined"> visibility_off </mat-icon>
                }
            </button>
        </div>

        <div class="col-auto">
            <button appPreventDoubleClick class="w-100" color="accent" mat-raised-button (throttledClick)="selectFullBatch(batchList[0].BatchCode)" [disabled]="Task.IsLoading > 0 || hasSampleBlockedInBatch(batchList[0].BatchCode)"
                    i18n>
                Tout selectionner
            </button>
        </div>

        @if (batchList[0].IsVisible) {
        <span class="mt-3">
            <!-- HEADER -->
            <div class="row text-center fst-italic">

                <div class="col"> Nom d'échantillon</div>
                <div class="col"> Code échantillon</div>
                <div class="col"> Matrice </div>
                <div class="col-1"> Sélection </div>
            </div>
            @for (sample of batchList; track sample.SampleCode) {
            <div>
                <div class="row align-items-center text-center mt-3" [style.color]="sample.IsBlocked ? 'red' : ''">

                    <div class="col"> {{sample.ClientSampleCode}} </div>
                    <div class="col"> {{sample.SampleCode}} </div>
                    <div class="col"> {{sample.Matrix}} </div>
                    <div class="col-1">
                        @if (!sample.IsBlocked) {

                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(sample) : null"
                                      [checked]="selection.isSelected(sample)">
                        </mat-checkbox>
                        }
                    </div>
                </div>
            </div>
            }
        </span>
        }
    </div>
    }
</div>